export default __webpack_public_path__ + "static/media/SuitcaseIcon.516690a9.svg";